import { Checkbox, Form } from "antd";
import Button from "@/common/elements/Button";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledInformationList,
  StyledSectionHeading,
} from "@/common/styles";
import CommonReportActionHeader from "@/components/CommonReport/CommonReportActionHeader";
import {
  StyledReportContainer,
  StyledReportContent,
} from "@/components/CommonReport/styles";
import CustomModal from "@/components/CustomModal";
import useDialog from "@/hooks/useDialog";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { FormContainer } from "@/components/InmateDetails/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";

const CashAccountPaymentForm = forwardRef(({ depositFormRef }) => {
  const [form] = Form.useForm();

  const [reportModal, setReportModal] = useState(false);
  const [depositData, setDepositData] = useState();

  useEffect(() => {
    setDepositData();
  }, []);

  useEffect(() => {
    if (isNonEmptyVariable(depositData)) {
      // form.setFieldsValue(depositData);
    } else {
      // form.resetFields();
    }
  }, [depositData]);

  const onConfirmReceipt = (cnf) => {
    console.log("dsadasd", cnf);
    if (cnf) {
      setReportModal(true);
    }
  };

  const onCloseHandler = () => {
    setReportModal(false);
  };

  const handleReceipt = () => {
    setReportModal(true);
    showDialog("confirm", {
      title: "Enter the name for the receipt.",
      confirmButtonText: "Okay",
      cancelButtonText: "Cancel",
      promptType: "text",
      onConfirm: (cnf) => onConfirmReceipt(cnf),
      prompt: true,
    });
  };

  // Expose the form methods to parent
  useImperativeHandle(depositFormRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    setFormValue: () => form.setFieldValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
  }));

  return (
    <>
      <Form form={form}>
        <StyledSectionHeading>
          <span>Please enter the amount of money being deposited:</span>
        </StyledSectionHeading>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={4}>
            <FormItem
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Amount is required",
                },
              ]}
            >
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={4}>
            <FormItem label="Check #" name="checkNumber">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem label="Category" name="category">
              <Select
                placeholder="Destination"
                variant="outlined"
                options={getOptionsFromRefList("Category")}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={4}>
            <FormItem label="Receipt #" name="receiptNumber">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol>
            <FormItem
              label="Deposit Type #"
              name="depositType"
              rules={[
                {
                  required: true,
                  message: "Deposit Type is required",
                },
              ]}
            >
              <Select
                placeholder="Destination"
                variant="outlined"
                options={getOptionsFromRefList("DepositType")}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={12}>
            <FormItem label="Received By" name="receivedBy">
              <StyledFlex gap="10px">
                <Select />

                <Button
                  color="secondary"
                  onClick={handleReceipt}
                  type="secondary"
                >
                  Receipt
                </Button>
              </StyledFlex>
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={16}>
            <FormItem label="Transaction Details" name="transactionDetails">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>

      {reportModal && (
        <CustomModal
          size="xl"
          show={reportModal}
          onHide={() => setReportModal(false)}
          header="BI2 technologies Report"
          hideFooter={true}
        >
          {<CommonReportActionHeader onClose={onCloseHandler} />}

          <StyledReportContainer>
            <div className="report-top-header">
              <div>
                <small>BI2 technologies - Receipt</small>
                <div>ANOKA COUNTY JAIL ANOKA, MN</div>
              </div>
            </div>
            <StyledInformationList>
              <div className="report-box">
                <div className="d-flex-item">
                  <h6 className="key">Date:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Received From:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Amount:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Check #:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Type:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Category:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Details:</h6>
                  <h6 className="value"></h6>
                </div>
                <div className="d-flex-item">
                  <h6 className="key">Received By:</h6>
                  <h6 className="value"></h6>
                </div>
              </div>
            </StyledInformationList>
          </StyledReportContainer>
        </CustomModal>
      )}
    </>
  );
});

export default CashAccountPaymentForm;
